import React from "react";

/**
 * Voxium Script wordmark.
 * Matches Voxium Core treatment:
 *   - Playfair Display
 *   - lowercase
 *   - serif, medium weight
 *
 * Variants:
 *   tone: "dark" (cream text for dark bg) | "light" (ink text for cream bg)
 *   size: "hero" | "footer" | "nav"
 *
 * The TM symbol is applied directly after "voxium" (the registered mark) and
 * before "script". Rendered in its own <sup> element so the mark "voxium"
 * remains an unbroken string in the DOM and in the bundle. Sized at 50% of
 * the surrounding text, no new colour (inherits the tone), vertical-align:
 * super (browser default on <sup>) — no layout shift, no wrap at 390 px.
 */
export const Wordmark = ({ tone = "light", size = "hero", testId = "wordmark" }) => {
  const toneClass = tone === "dark" ? "text-creamtext" : "text-nearblack";

  const sizeClass = {
    hero: "text-3xl sm:text-4xl",
    footer: "text-xl sm:text-2xl",
    nav: "text-base sm:text-lg",
  }[size];

  return (
    <span
      className={`wordmark ${sizeClass} ${toneClass} leading-none whitespace-nowrap`}
      data-testid={testId}
    >
      voxium<sup className="font-ui text-[0.5em] ml-[0.08em] tracking-normal" data-testid={`${testId}-tm`}>™</sup> <span className="text-gold">script</span>
    </span>
  );
};

export default Wordmark;
